/*
.. Modified by Kishore Jalleda
.. full list of modifications at https://github.com/unstructai
.. copyright: (c) 2023 Kishore Jalleda
.. author:: Kishore Jalleda <kjalleda@gmail.com>
*/
import { DefaultLayout, DashboardLayout, BasicLayout } from "@/components/layouts"


const withPrefix = (prefix, routes) =>
  routes.map((route) => {
    route.path = prefix + route.path
    return route
  })

const authPages = [
  {
    path: "login",
    name: "BasicLogin",
    component: () => import("@/auth/Login.vue"),
  },
  {
    path: "post-oauth-login",
    name: "PostOauthLogin",
    component: () => import("@/auth/PostOauthLogin.vue"),
  }
]

export const publicRoute = [
  {
    path: "*",
    meta: { title: "Dispatch" },
    component: () => import("@/views/error/NotFound.vue"),
  },
  {
    path: "/:organization/auth/",
    component: BasicLayout,
    meta: { title: "Auth", icon: "view_compact", group: "auth" },
    children: authPages,
  },
  {
    path: "/:organization/landing",
    name: "BasicChat",
    meta: { title: "Public Chat", requiresAuth: false },
    props: route => ({
      chatId: route.query.chat_id,
      isSharedView: !!route.query.chat_id
    }),
    component: () => import("@/websocket/ChatContainer.vue"),
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "Not Found" },
    component: () => import("@/views/error/NotFound.vue"),
  },
  {
    path: "/500",
    name: "500",
    meta: { title: "Server Error" },
    component: () => import("@/views/error/Error.vue"),
  },
  {
    path: "/implicit/callback",
    name: "PKCEImplicityCallback",
    meta: { requiresAuth: true },
  },
  {
    path: "/:organization/legal/terms-of-service",
    name: "TermsOfService",
    meta: { title: "Terms of Service", requiresAuth: false },
    component: () => import("@/legal/TermsOfService.vue"),
  },
  {
    path: "/:organization/legal/privacy-policy",
    name: "PrivacyPolicy",
    meta: { title: "Privacy Policy", requiresAuth: false },
    component: () => import("@/legal/PrivacyPolicy.vue"),
  },
  {
    path: "/:organization/help/faq",
    name: "FAQ",
    meta: { title: "Frequently Asked Questions", requiresAuth: false },
    component: () => import("@/help/FAQ.vue"),
  },
  {
    path: "/:organization/blog/:id?",
    name: "Blog",
    meta: { title: "Blog", requiresAuth: false },
    component: () => import("@/blog/UnstructBlog.vue"),
  },
]

// NOTE: The order in which routes are added to the list matters when evaluated. For example, /iaos/report will take precendence over /iaos/:name.
export const protectedRoute = [
  {
    path: "/",
    meta: { requiresAuth: true },
    name: "Root",
    component: () => import("@/components/RootRedirect.vue"),
  },
  ...withPrefix("/:organization/", [
    {
      path: "admin/settings",
      name: "AdminSettings",
      meta: { title: "Admin Settings", requiresAuth: true },
      component: () => import("@/admin_settings/AdminSettings.vue"),
    },
    {
      path: "admin/content_manager",
      name: "AdminContentManager",
      meta: { title: "Content Manager", requiresAuth: true },
      component: () => import("@/websocket//curated_content/AdminContentManager.vue"),
    },
    {
      path: "upgrade",
      name: "upgradePlan",
      meta: { title: "Upgrade", requiresAuth: true },
      component: () => import("@/components/UpgradePlan.vue"),
    },
    {
      path: "chat",
      name: "chat",
      meta: { title: "Chat", requiresAuth: true },
      props: route => ({
        chatId: route.query.chat_id,
        isSharedView: !!route.query.chat_id
      }),
      component: () => import("@/websocket/ChatContainer.vue"),
    },
    {
      path: "settings",
      component: DefaultLayout,
      name: "settings",
      meta: {
        title: "Settings",
        icon: "mdi-cogs",
        color: "pink",
        group: "settings",
        menu: true,
        requiresAuth: true,
      },
      children: [
        {
          path: "members",
          name: "OrganizationMemberTable",
          meta: { title: "Members", subMenu: "organization", group: "organization" },
          component: () => import("@/organization/OrganizationMemberTable.vue"),
        },

      ],
    },
  ]),
]
